import React from 'react';
import PageIntro from '../ui/PageIntro';

/**
 * Единый header для всех страниц приложения (R13).
 *
 * Props:
 *   icon: lucide-react компонент (optional)
 *   iconColor: цвет иконки (default: brand purple)
 *   title: строка
 *   subtitle: строка
 *   right: JSX для правой стороны (кнопки)
 *
 * Использование:
 *   <PageHeader icon={Sparkles} title="Дашборд" subtitle="..." right={<button>Экспорт</button>}/>
 */
export default function PageHeader({ icon: Icon, iconColor, title, subtitle, right, children }) {
  return (
    <PageIntro
      icon={Icon}
      iconColor={iconColor}
      title={title}
      description={subtitle}
      aside={right ? <div className="workspace-side-actions">{right}</div> : null}
    >
      {children}
    </PageIntro>
  );
}
